import {gql} from '@apollo/client';

export const CREATE_FEEDBACK = gql`
    mutation CreateFeedback(
        $contacts: String!,
        $description: String!,
        $name: String!
    ) {
        createFeedback(
            contacts: $contacts,
            description: $description, 
            name: $name,
            option: 2
        ) {
            feedback{
                id
            }
        }
    }
`;
